/**
 * Pure auto-context collector for feedback submissions.
 *
 * `win` and `now` are injected so the function is fully unit-testable
 * without jsdom monkey-patching. In production, callers pass `window`
 * and `() => new Date()`.
 *
 * Returns the five fields documented in
 * docs/superpowers/specs/2026-05-18-feedback-mechanism-design.md §3.
 */
export const collectContext = ({ win, dashboardVersion, now }) => ({
  pageUrl: win.location.href,
  dashboardVersion: dashboardVersion || 'unknown',
  userAgent: win.navigator.userAgent,
  screenSize: `${win.innerWidth}x${win.innerHeight}`,
  clientTimestamp: now().toISOString(),
});
